import ApiService from "@/core/services/api.service";
import {API_URL} from '@/common/config.js'

const apiService = ApiService;


export default class IssueService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/library/issue`;

    }

    paginate(data = {}, index = null) {
        let url = `${this.#api}`;
        if (index)
            data.page = index;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }
    getAllNotReturnedBook(data = {}, index = null){
        let url = `${this.#api}/not-return-list`;
        if (index)
            data.page = index;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    first() {
        let url = `${this.#api}`;
        return apiService.get(url);
    }

    update(id, data) {
        let url = `${this.#api}/${id}`
        return apiService.put(url, data);

    }


    store(data) {
        let url = `${this.#api}`
        return apiService.post(url, data);

    }

    show(id) {
        let url = `${this.#api}/${id}`
        return apiService.get(url);
    }

    sort(data) {
        let url = `${this.#api}/sort`;
        return apiService.post(url, data);
    }


    delete(id) {
        let url = `${this.#api}/${id}`
        return apiService.delete(url);
    }

    getBookIssuedList(bookId) {
        let url = `${this.#api}/book/${bookId}`;
        return apiService.get(url);
    }

    getBookPendingReturn(bookId) {
        let url = `${this.#api}/book/${bookId}/pending-return`;
        return apiService.get(url);
    }

    issuedBook(userId, type) {
        let url = `${this.#api}/user/${userId}/${type}`;
        return apiService.get(url);
    }

    checkBookAvailability(userId, bookId) {
        let url = `${this.#api}/user/${userId}/book/${bookId}/check-availability`;
        return apiService.get(url);
    }

    expiryReport() {
        let url = `${this.#api}/expiry/report`;
        return apiService.get(url);
    }

    issueBookForUser(userId, data) {
        let url = `${this.#api}/user/${userId}/issue-book`;
        return apiService.post(url, data);
    }

    issueTimeline(userId) {
        let url = `${this.#api}/user/${userId}/time-line/report`;
        return apiService.get(url);
    }

    getMostIssuedList(data) {
        let url = `${this.#api}/most-issued/books`;
        return apiService.post(url, data);
    }

    getExpiryList(data, index = null) {
        let url = `${this.#api}/expiry-list/all`;
        if (!index)
            url = url + '?page=' + index
        return apiService.post(url, data);
    }

    getByStudentCardId(studentCardId) {
        let url = `${this.#api}/summary-by/student/card-id/${studentCardId}`;
        return apiService.post(url);
    }

    returnStudentBooks(data) {
        let url = `${this.#api}/return-books`;
        return apiService.post(url, data);
    }

    renewBooks(data) {
        let url = `${this.#api}/renew-books`;
        return apiService.post(url, data);
    }

    exportIssueList(data) {
        let url = `${this.#api}/list/export`;
        let queryString = Object.keys(data).map(key => {
            if (data[key] && data[key] != undefined && data[key] != "") {
                return `${key}=${data[key]}`
            }
        });
        queryString = queryString.filter(function (e) {
            return e != null;
        });
        queryString = queryString.join("&");
        url = url + "?" + queryString;
        window.open(url, '_blank')
    }

    exportReturnList(data) {
        let url = `${this.#api}/return-list/export`;
        let queryString = Object.keys(data).map(key => {
            if (data[key] && data[key] != undefined && data[key] != "") {
                return `${key}=${data[key]}`
            }
        });
        queryString = queryString.filter(function (e) {
            return e != null;
        });
        queryString = queryString.join("&");
        url = url + "?" + queryString;
        window.open(url, '_blank')
    }
    checkDuplicateBook(data){
        let url = `${this.#api}/check/duplicate-book`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }
    exportBookIssuedHistory(bookId,data={}){
        let url = `${this.#api}/${bookId}/book-issued-history`;
        if (data != null && data != undefined && data != "") {
            var queryString = Object.keys(data).map((key) => {
                if (data[key] && data[key] != null)
                    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }).join('&');
            url = url + '?' + queryString;
        }
        window.open(url);
    }
}